import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ProspectSettingsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--members--prospects']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
